import { useState } from 'react';

const faqItems = [
  {
    q: '51漫画网真的免费吗？需要注册吗？',
    a: '51漫画网所有漫画内容完全免费，无需注册即可畅读。您可以直接打开网站开始51漫画在线观看，没有任何付费墙。如果您想收藏作品或参与社区互动，可以选择免费注册账号，但这并非阅读的必需要求。',
  },
  {
    q: '51漫画在线的阅读体验和其他平台有什么不同？',
    a: '51漫画网采用独创的下拉式阅读技术，您只需向下滑动即可无缝连续阅读，无需频繁点击翻页按钮。配合高清画质和预加载技术，51漫画在线看全集实现了零等待的流畅体验，大幅提升阅读沉浸感。',
  },
  {
    q: '51漫画免费观看支持哪些设备？画面清晰度如何？',
    a: '51漫画在线阅读支持手机、平板、电脑等所有主流设备，页面会自动适配屏幕尺寸。所有漫画均以高清分辨率呈现，画质细腻锐利。为节省流量，您也可以在设置中调整画质选项以适配不同网络环境。',
  },
  {
    q: '漫画更新频率如何？新作品多久上架？',
    a: '51漫画网编辑团队7×24小时跟进热门连载更新，每日新增超过200话内容。热门作品通常在原作发布后2小时内同步更新。新作品上架方面，我们每周都会筛选优质原创漫画加入平台，同时积极引进国内外优秀漫画版权。',
  },
];

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-heading text-2xl md:text-3xl text-foreground-950 mb-3">常见问题</h2>
          <p className="text-sm text-foreground-600">关于51漫画网的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer bg-transparent border-0"
              >
                <h3 className="text-sm font-semibold text-foreground-900 pr-4">{item.q}</h3>
                <i
                  className={`ri-arrow-down-s-line text-foreground-400 text-lg transition-transform duration-300 flex-shrink-0 ${
                    openIdx === idx ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIdx === idx ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <p className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}